import Header from "../components/header/Header";
import MessageModals from "../components/modals/MessageModals";
import DesktopView from "../components/desktopview/DesktopView";

import React, { useContext, useEffect, useState } from "react";
import { INVITE_TEXT } from "../constants/inviteText.js";
import { MdOutlineContentCopy, MdOutlineVerifiedUser } from "react-icons/md";
import axios from "axios";
import { useCookies } from "react-cookie";
import globalContext from "../Contexts/GlobalContext";
import { SERVERMODE } from "../constants/serverMode.js";
import { handleServerMode } from "../utils/handleServer.js";
import { useNavigate } from "react-router-dom";
import BlueLoader from "../components/loader/BlueLoader.jsx";
import useRequestHeader from "../hooks/useRequestHeader.js";

export default function Invite() {
  /// root api address section start ///
  const BASE_URL = process.env.REACT_APP_ROOT_API_ADDRESS;
  const contextData = useContext(globalContext);
  const requestHeader = useRequestHeader();
  const navigate = useNavigate();
  /// root api address section end ///
  const [cookies, setCookies, removeCookies] = useCookies();
  const [isLoading, setISLoading] = useState(false);
  const [identifiCode, setIdentifiCode] = useState("");

  const [isCopied, setIsCopied] = useState(false);

  const shareData = {
    title: "دعوت از دوستان",
    text: `${INVITE_TEXT}${identifiCode}`,
  };
  useEffect(() => {
    const config = {
      headers: requestHeader,
    };
    setISLoading(true);
    axios
      .post(`${BASE_URL}/user/info/identifiCode`, {}, config)
      .then((res) => {
        var responseMode = res?.data?.Mode;
        var responseMessage = res?.data?.Message;
        switch (responseMode) {
          case SERVERMODE.REQUEST_OK: {
            setIdentifiCode(res?.data?.Data?.identifiCode);
            break;
          }
          default: {
            handleServerMode(
              responseMode,
              responseMessage,
              contextData,
              cookies,
              removeCookies,
              navigate
            );
          }
        }
        setISLoading(false);
      })
      .catch((err) => {
        contextData.setIsToastOpen(true);
        contextData.setToastMessage("ارتباط با سرور دچار مشکل شده است");
        setISLoading(false);
      });
  }, []);
  return (
    <>
      {contextData.isToastOpen && (
        <MessageModals
          message={contextData.toastMessage}
          setIsOpen={contextData.setIsToastOpen}
          bottom={5}
        />
      )}
      <div className="hidden min-[1024px]:block">
        <DesktopView />
      </div>
      <div
        className="relative w-full h-screen flex flex-col items-center justify-between bg-[#153038] min-[1024px]:hidden"
        onClick={() => {}}
      >
        <Header relt="relative" />

        <span className="absolute w-full h-[50vh] bg-color-primary-B z-0 flex items-end justify-between">
          <span className="w-[10vw] h-[10vw] bg-[#153038] rounded-tl-full"></span>
          <span className="w-[10vw] h-[10vw] bg-[#153038] rounded-tr-full"></span>
        </span>
        <span className="absolute top-0 w-[80%] h-[80vh] bg-color-primary-B rounded-[8vw] z-[5] flex items-end justify-center ">
          <div className="w-[90%] h-[30%] flex flex-col items-center justify-evenly">
            <p className="w-full font-font_primary_A text-[3vw] text-[#153038] text-center">
              کد دعوت زیر را برای دوستان خود ارسال کنید تا در زمان ثبت نام و
              ورود به اپلیکیشن اسکارپین از آن استفاده نمایید.
            </p>

            <div
              className="relative w-[60vw] h-[10vw] px-[4vw] py-[1vw] rounded-[2vw] border-[1.5px] border-dashed flex items-center justify-between gap-x-3  "
              onClick={() => {
                if (!isLoading) {
                  navigator.clipboard
                    .writeText(`${identifiCode}`)
                    .then(() => {
                      setIsCopied(true);
                      contextData.setIsToastOpen(true);
                      contextData.setToastMessage("کد دعوت کپی شد");
                    })
                    .catch(() => {});
                }
              }}
            >
              {isLoading && (
                <div className="absolute top-0 right-0 w-full h-full backdrop-blur-[1px]   px-[4vw] py-[1vw] rounded-[2vw] border-[1.5px] border-dashed flex items-center justify-center ">
                  <BlueLoader position="" width={10} />
                </div>
              )}

              <span className="absolute top-0 left-0 w-full h-full bg-[#e4e4e4] rounded-[2vw] opacity-40 z-0"></span>
              <p className="font-font_primary_A text-[3.5vw] text-[#153038] font-medium text-center z-10">
                کد دعوت:
              </p>

              <p className="font-font_primary_D text-[5.5vw] text-[#153038] font-medium text-center z-10">
                {identifiCode}
              </p>

              {isCopied ? (
                <MdOutlineVerifiedUser className="w-[4vw] " color="green" />
              ) : (
                <MdOutlineContentCopy className="w-[4vw] " />
              )}
            </div>
          </div>
        </span>
        <div
          className={` w-[95vw] h-full flex flex-col items-center justify-between px-[6vw] gap-y-[2vw] mb-[2vw]`}
        >
          <img
            src="../assets/images/body/gift.png"
            alt=""
            className="absolute top-[30%] w-[80vw] min-[400px]:w-[70vw] z-10"
          />
          <div className="w-full h-auto flex flex-col items-center justify-between px-[2vw] mt-[8vw] z-10 ">
            <p className="font-font_primary_A text-[5.5vw] text-[#153038] font-bold">
              دعوت از دوستان
            </p>
            <p className="font-font_primary_A text-[3vw] mt-[2vw] text-[#153038] font-semibold">
              دوستان خود را به سامانه اسکارپین دعوت کنید
            </p>
          </div>
          <div className="w-[70vw] h-[18vh] flex items-center justify-center ">
            <button
              className="font-font_primary_A font-semibold text-[4.5vw] w-[80vw] h-[10vw] flex flex-col items-center justify-between p-[2vw] bg-color-primary-B rounded-[2vw]"
              onClick={async (e) => {
                e.stopPropagation();
                try {
                  await navigator.share(shareData);
                } catch (err) {}
              }}
            >
              ارسال دعوت‌نامه
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
